<template>
    <router-link :to="link">
        <div class="bouton openSans font-bold white dashed-space-all">
            <i class="fas fa-arrow-right"></i>
        </div>
    </router-link>
</template>

<script>
export default {
    name: "BoutonNext",
    props: {
        link: String
    }
};
</script>

<style scoped lang="scss">
.bouton {
    width: 30%;
    padding: 25px;
    position: fixed;
    right: 0;
    bottom: 0;

    i {
        font-size: 2rem;
    }
}
.white {
    background-color: white;
    color: #4500b6;
}
</style>
